module.exports = __webpack_public_path__ + "static/moa-graphic-mobile_rev2-50a6f4eedd14c09592573792d8da249b.png";